import React, { memo, useCallback, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'
import DashboardLayout from '../../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet/es/Helmet'
import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Select,
  Tooltip,
  Upload,
} from 'antd'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import {
  CloudUploadOutlined,
  DeleteOutlined,
  FileTextOutlined,
} from '@ant-design/icons'
import {
  DraggerUploadStyled,
  FormActionFooter,
  UploadFileListItem,
  UploadFileListWrapper,
  ViewDetailContent,
} from './BoardResolutionMinutesUpdateStyled'
import validator from '../../../validator'
import { Container } from '../../../layouts/Container/Container'
import { DATE_FORMAT_LIST } from '../../../constants'
import moment from 'moment'

const BoardResolutionMinutesUpdate = props => {
  const { Option } = Select
  const { Dragger } = Upload
  const {
    loadingAnimationStore,
    boardResolutionMinutesStore,
    match,
    fileStore,
    history,
  } = props

  const [form] = Form.useForm()

  const [fileList, setFileList] = useState([])
  const [fileListUpdate, setFileListUpdate] = useState([])
  const [originalData, setOriginalData] = useState({})

  const { documentId } = match.params

  const handleAddFileToUpload = () => false
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }

  const handleChangeFile = useCallback(
    info => {
      form.setFieldsValue({
        file_id: info.fileList.slice(
          info.fileList.length - 1,
          info.fileList.length
        ),
      })
      setFileList(
        info.fileList.slice(info.fileList.length - 1, info.fileList.length)
      )
    },
    [form]
  )

  useEffect(() => {
    loadingAnimationStore.showSpinner(true)
    boardResolutionMinutesStore
      .getBoardResolutionMinutesDetail(documentId)
      .then(
        res => {
          loadingAnimationStore.showSpinner(false)
          boardResolutionMinutesStore.getviewBoardFile({
            recordId: res.data.id,
            fileId: res.data.file_id,
          })

          const formData = {
            file_id: res.data.file_id,
            document_name: res.data.document_name?.trimStart(),
            document_number: res.data.document_number?.trimStart(),
            contruction_board: res.data.contruction_board?.trimStart(),
            issue_date: moment(res.data.issue_date),
            status: res.data.status === 'NEW' ? undefined : res.data.status,
            file_name: res.data.file_name,
            issue_level: res.data.issue_level?.trimStart(),
          }

          form.setFieldsValue(formData)

          const originalFormData = {
            document_name: res.data.document_name?.trimStart() || null,
            document_number: res.data.document_number?.trimStart() || null,
            contruction_board: res.data.contruction_board?.trimStart() || null,
            issue_level: res.data.issue_level?.trimStart() || null,
            status: res.data.status === 'NEW' ? null : res.data.status || null,
            issue_date: res.data.issue_date,
            file_id: res.data.file_id,
          }

          setOriginalData(originalFormData)

          setFileList([
            {
              name: res.data.file_name,
              id: res.data.file_id,
              uid: 1,
              type: 'application/pdf',
            },
          ])
        },
        error => {
          message.error(error.vi)
          loadingAnimationStore.showSpinner(false)
        }
      )
    return () => boardResolutionMinutesStore.clearBoardHDQTDetail()
  }, [boardResolutionMinutesStore, documentId, form, loadingAnimationStore])

  const compareData = (originalData, currentValues) => {
    const currentData = {
      ...currentValues,
      status: currentValues.status || null,
    }

    const fieldsToCompare = [
      'document_name',
      'document_number',
      'contruction_board',
      'issue_level',
      'status',
    ]

    for (const field of fieldsToCompare) {
      const originalValue = originalData[field] || null
      const currentValue = currentData[field] || null

      if (originalValue !== currentValue) {
        return false
      }
    }

    if (currentData.issue_date && moment.isMoment(currentData.issue_date)) {
      const currentDateString = currentData.issue_date
        .hour(12)
        .minute(0)
        .second(0)
        .toISOString()

      const originalDate = moment(originalData.issue_date)
        .hour(12)
        .minute(0)
        .second(0)
        .toISOString()

      if (originalDate !== currentDateString) {
        return false
      }
    }

    if (
      currentData.file_id &&
      Array.isArray(currentData.file_id) &&
      currentData.file_id.length > 0 &&
      currentData.file_id[0] &&
      currentData.file_id[0].originFileObj
    ) {
      return false
    }

    return true
  }

  const handleSubmitForm = async values => {
    if (compareData(originalData, values)) {
      message.warning('Không có giá trị thay đổi')
      return
    }

    loadingAnimationStore.showSpinner(true)

    const submitData = {
      ...values,
      status: values.status || null,
    }
    if (submitData.issue_date && moment.isMoment(submitData.issue_date)) {
      submitData.issue_date = submitData.issue_date
        .hour(12)
        .minute(0)
        .second(0)
        .toISOString()
    }

    if (
      submitData.file_id &&
      submitData.file_id.length > 0 &&
      submitData.file_id[0] &&
      submitData.file_id[0].originFileObj
    ) {
      const formData = new FormData()
      formData.append('file', submitData.file_id[0].originFileObj)
      fileStore
        .uploadFile(formData)
        .then(response => {
          submitData.file_id = response.data.file_id
          handleUpdateBoardHDQT(documentId, submitData)
          loadingAnimationStore.showSpinner(false)
        })
        .catch(error => {
          message.error(error.vi)
          loadingAnimationStore.showSpinner(false)
        })
    } else {
      // not update new file
      submitData.file_id = fileList[0].id
      handleUpdateBoardHDQT(documentId, submitData)
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleUpdateBoardHDQT = useCallback(
    (documentId, submitData) => {
      boardResolutionMinutesStore
        .updateBoardResolutionMinutes(documentId, submitData)
        .then(() => {
          loadingAnimationStore.showSpinner(false)
          message.success(`Cập nhật biên bản nghị quyết thành công`)
          history.push(`/board-resolution-minutes-hdqt/view/${documentId}`)
        })
        .catch(error => {
          loadingAnimationStore.showSpinner(false)
          message.error(error.vi)
        })
    },
    [boardResolutionMinutesStore, history, loadingAnimationStore]
  )

  const handleCancel = () => {
    form.resetFields()
    history.push(`/board-resolution-minutes-hdqt/view/${documentId}`)
  }

  const renderListFileUpdate =
    fileListUpdate &&
    fileListUpdate.map((file, index) => (
      <UploadFileListItem key={file.id}>
        <FileTextOutlined style={{ color: '#1890FF' }} />
        <span style={{ color: '#1890FF' }}>{file.name}</span>

        <Tooltip title={'Xoá tập tin'}>
          <DeleteOutlined onClick={() => setFileListUpdate([])} />
        </Tooltip>
      </UploadFileListItem>
    ))

  const renderFormContent = () => (
    <ContentBlockWrapper>
      <Container maxWidth={820}>
        <Form
          scrollToFirstError={true}
          {...layout}
          form={form}
          name={'add-vbpc-form'}
          onFinish={handleSubmitForm}>
          <Form.Item
            name={'document_name'}
            label={'Tên văn bản'}
            rules={[
              { required: true, message: 'Vui lòng nhập tên văn bản' },
              { validator: validator.validateInputString },
            ]}>
            <Input placeholder={'Nhập tên văn bản'} />
          </Form.Item>

          <Form.Item
            name={'document_number'}
            label={'Số quyết định ban hành'}
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập số quyết định ban hành',
              },
              { validator: validator.validateInputString },
            ]}>
            <Input placeholder={'Nhập số quyết định ban hành'} />
          </Form.Item>

          <Form.Item
            name={'issue_date'}
            label={'Ngày ban hành'}
            rules={[
              {
                required: true,
                message: 'Vui lòng chọn ngày ban hành',
              },
            ]}>
            <DatePicker style={{ width: '100%' }} format={DATE_FORMAT_LIST} />
          </Form.Item>

          <Form.Item name={'issue_level'} label={'Cấp ban hành'}>
            <Input placeholder={'Nhập cấp ban hành'} />
          </Form.Item>

          <Form.Item name={'contruction_board'} label={'Ban chủ trì xây dựng'}>
            <Input placeholder={'Nhập ban chủ trì xây dựng'} />
          </Form.Item>

          <Form.Item name={'status'} label={'Trạng thái'}>
            <Select
              showSearch
              allowClear
              placeholder={'Trạng thái'}
              filterOption={true}
              optionFilterProp={'name'}>
              {[
                { label: 'Đã bãi bỏ', value: 'ABOLISHED' },
                { label: 'Hết hiệu lực', value: 'EXPIRED' },
                { label: 'Còn hiệu lực', value: 'ACTIVE' },
              ].map(({ label, value }) => (
                <Option key={value} name={label} value={value}>
                  {label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name={'file_id'}
            label={'Tài liệu đính kèm'}
            rules={[{ required: true, message: 'Vui lòng thêm tài liệu' }]}>
            <Dragger
              valuePropName={'fileList'}
              fileList={fileList}
              onChange={handleChangeFile}
              beforeUpload={handleAddFileToUpload}>
              <DraggerUploadStyled>
                <CloudUploadOutlined />
                <span>Kéo thả hoặc click vào để tải lên tài liệu</span>
              </DraggerUploadStyled>
            </Dragger>
          </Form.Item>
          {
            <UploadFileListWrapper>
              {renderListFileUpdate}
            </UploadFileListWrapper>
          }

          <FormActionFooter>
            <Button onClick={handleCancel}>Huỷ bỏ</Button>
            <Button
              style={{ marginLeft: 10 }}
              type={'primary'}
              htmlType={'submit'}>
              Cập nhật biên bản
            </Button>
          </FormActionFooter>
        </Form>
      </Container>
    </ContentBlockWrapper>
  )

  return (
    <DashboardLayout>
      <Helmet>
        <title>Chi tiết biên bản nghị quyết</title>
      </Helmet>
      <PageTitle
        location={props.location}
        title={'Chi tiết biên bản nghị quyết'}
        routerGoback={'/board-resolution-minutes-hdqt'}
      />
      <ViewDetailContent>{renderFormContent()}</ViewDetailContent>
    </DashboardLayout>
  )
}

BoardResolutionMinutesUpdate.propTypes = {}

export default memo(
  inject(
    'loadingAnimationStore',
    'commonStore',
    'fileStore',
    'boardResolutionMinutesStore'
  )(observer(BoardResolutionMinutesUpdate))
)
